import React from 'react';
import { Body5, Container } from '@ui';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper } from '@flow/styles';
import styled from 'styled-components';

const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0 0 4px;
  box-sizing: border-box;
  width: 100%;
`;

const CheckboxRow = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  cursor: pointer;
  min-width: 0;
  user-select: none;
  padding: 2px 0;
  width: 100%;
`;

const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  && {
    background-color: transparent;
    cursor: pointer;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    width: auto;
  }
`;

const CheckboxLabel = styled(Body5)`
  display: block;
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const FixedOptionListParameter = ({ data, value, onRemove, onChange }) => {
  const { keyName, label, fixedOptions } = data;
  const selected = Array.isArray(value) ? value : [];

  const toggle = (id) => {
    const next = selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id];
    onChange(keyName, next);
  };

  return (
    <AgentFlowParameterWrapper style={{ flexDirection: 'column', alignItems: 'flex-start', minHeight: 'auto' }}>
      <Container fullWidth>
        <Container row verticallyCenter spaceBetween fullWidth>
          <AgentFlowParameterLabelWrapper>
            <Body5>{label}:</Body5>
          </AgentFlowParameterLabelWrapper>
          <NodeParameterRemoveButton onClick={() => onRemove(keyName)} />
        </Container>
        <OptionsList>
          {(fixedOptions || []).map((option) => (
            <CheckboxRow key={option.id}>
              <CheckboxInput checked={selected.includes(option.id)} onChange={() => toggle(option.id)} />
              <CheckboxLabel>{option.label}</CheckboxLabel>
            </CheckboxRow>
          ))}
        </OptionsList>
      </Container>
    </AgentFlowParameterWrapper>
  );
};
